import React from 'react';
import '../assets/css/About.css'; 
import story from '../assets/images/story.svg';  


const AboutUs = () => {
  return (
    <div id="about">
    <div className="about-us">
      {/* Header Section */}
      <section className="intro">
        <div className="content">
          <h1 className="fade-in">About Us</h1>
          <p className="fade-in">We are a passionate team dedicated to making a difference in the world by solving real problems through technology.
             Our goal is to create solutions that are simple to use, impactful, and help businesses grow. 
             Our journey started with a simple idea: to use innovation and creativity to streamline processes and improve how people work. 
             Over time, we built a strong team, expanded our skills, and successfully delivered products that have helped transform businesses in various industries. 
             We believe that by focusing on what matters most our clients, their needs, and their challenges we can create meaningful, long lasting impact. With every project, 
             we aim to deliver high-quality solutions that simplify complex processes, enhance user experience, and bring about positive change.</p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="our-story">
        <div className="story-content fade-in-left">
          <h2>Our Story</h2>
          <p>Our story began with a small but dedicated group of individuals who were united by a shared passion for technology and innovation. 
            From the very beginning, we focused on solving real-world challenges and creating products that help businesses thrive in an ever-changing world. 
            Throughout our journey, we’ve faced challenges, but each obstacle has helped us grow. 
            Today, we continue to push the boundaries of what’s possible, striving to build better solutions that address both current and future challenges. 
            Every milestone we’ve achieved has been possible thanks to our talented team, loyal clients, and partners who share our vision of creating a smarter, more connected world. 
            We’re excited about the future and committed to continually improving how we do business. We believe that the best is yet to come!</p>
        </div>
        <div className="story-image fade-in-right">
          <img src={story} alt="Our Story" />
          
        </div>
      </section>

      {/* Mission & Values Section */}
      <section className="values">
        <div className="content fade-in-left">
          <h2>Our Mission & Values</h2>
          <p>Our mission is simple: to build technology that makes life easier for people and businesses. We aim to create products that are both functional and user-friendly,
             ensuring that our clients get the most out of every solution we provide. Our core values guide everything we do. They include:
          </p>
          <br></br><br></br>
          <div className="values-container">
            <div className="value-box">
            <h3>Innovation</h3>
            <p>We are always looking for new ways to solve problems and improve.</p>
            </div>
            <div className="value-box">
            <h3>Integrity</h3>
            <p>We act with honesty and transparency in everything we do.</p>
            </div>
            <div className="value-box">
            <h3>Collaboration</h3>
            <p>We believe in working together to achieve great results.</p>
            </div>
            <div className="value-box">
            <h3>Customer Focus</h3>
            <p>We put our clients at the heart of everything we do, listening to their needs and delivering results that make a difference.</p>
            </div>
        </div>    

        </div>
      </section>
    </div>
    <section className="full-width-image">
        <div className="overlay">
            <h2>Transform Your Business with Our Services</h2>
            <p>We provide innovative solutions tailored to your needs.</p>
        </div>
        </section>
    </div>
  );
};

export default AboutUs;

